import React  from 'react';
import UserActions from 'lib/userActions';
import Grid from '@material-ui/core/Grid';
import NoMatch from 'components/noMatch';
import Login from 'components/login';
import ListingSkeleton from './listingSkeleton';
import {
    LargeSecondaryButton,
    InfoMicroscopeAlert,
    MediumPrimaryButton,
    ModalPattern,
    LargeLinkButton,
    LongCtaPopup
} from '@worthy-npm/clarity';

import I18n from 'lib/i18n/i18n';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getItem } from 'actions/item';
import Settings from '../settings/settings';
import {
    isMobile,
    rootUrl,
    imageUrl,
    requestShippingKitPopupText,

    STEP_ADDRESS,
    STEP_PICKUP,
    STEP_PHONE,
    STEP_MESSAGE,

    SHIPMENT_METHOD,
    LS,
    ESTIMATION_READY,
    ADDRESS_WAITING,
    SHIPPING,
    PICKUP_WAITING,
    NEW,
    IN_TRANSIT,
    SHIPMENT_DOM_ID,
    DELIVERED,
    LD_SK_EXP_VERSION,
    p13nServiceDecisions,

    OPENED_SCHEDULE_MODAL
} from 'helpers/ApplicationHelper';
import {DEFAULT_PHONE} from '../../constants/register';
import Stages from './stages';
import Services from './preAuctionServices';
import ListingFAQ from "./listingFAQ";
import PopupListing from '../popups/popupListing';
import WorthyApiErrors from 'lib/api/worthyApiErrors';
import SimilarItemsContainer from '../similarItemsContainer';
import ShipmentInformation from './shipmentInformation';
import ScheduleShipmentModalPopup from "../popups/scheduleShipmentModalPopup";

import { StickyButton } from "../common";

import ScheduleShipment from "../scheduleShipment/scheduleShipment";
import PopupListingReminder from "../popups/popupListingReminder";
import ListingReminder from "./listingReminder";
import {requestShippingKit} from "../../actions/shipment";
import {preShipmentUi} from "../../actions/personalize";
import Survey from "../survey";
export const SHIPPING_KIT = 'shipping_kit';
import Item from '../../components/item.js';
import ListingAlerts from "./listingAlerts";
import Intercom from "lib/intercom";

const stylesForText = {
    fontSize: '16px',
    lineHeight: '22px',
};

class Listing extends React.Component {
    constructor(props) {
        super(props);
        const itemId = this.props.params.itemId;

        this.shallWeSection = React.createRef();
        this.pageHeader = React.createRef();
        this.headAlert = React.createRef();
        this.settingsSection = React.createRef();

        this.bottomStickyObserver = null;
        this.isSnapEngage = false;
        this.desktopStickyObserver = null;
        this.desktopStickyObserver2 = null;
        this.isMobile = isMobile();

        this.state = {
            requestingNewItem: false,
            showStickyShipmentButton: false,
            showStickyShipmentButtonDt: false,
            availableAE: false,
            isChatOpen: false,
            settingUpShippingStep: 1,
            openRemindLaterForm: false,
            stickyBoxStyle: {},
            bannerPresented: false,
            prevObserverYPosition: 0,
            showNoPhoneSurvey: false,
            noPhoneSurveyPresented: false,
            initialized: false,
            openCompleteAccountModal: false
        };
        this.props.getItem(itemId);
        this.gettingP13N = false;
    }

    static getDerivedStateFromProps(props, state) {
        const { ADO, item, Session, P13N } = props;

        if (ADO && item && Session && P13N.preShipmentUi) {
            if (!Listing.version) {
                Listing.setVersion(props);
                UserActions.listingPage('Listing page presented', item.id, Listing.version);
            }
            window.localStorage.setItem('LISTING_VERSION'+'-'+item.id, Listing.version)
            state.initialized = true
        }

        if (item) {
            Listing.STICKY_BUTTON_TEXT = I18n.getString('listingPage::stickyBtnContentSchedule');
            if (item.shipment && (typeof(item.shipment.shipment_method) !== 'undefined') && item.shipment.shipment_method === SHIPMENT_METHOD['Pickup']) {
                Listing.STICKY_BUTTON_TEXT = I18n.getString('listingPage::stickyBtnContentEdit');
            }
        }

        return state;
    }

    static getVersion(props) {
        const { P13N } = props;

        const personalizedListingVersion = {
            [p13nServiceDecisions.hybridHvCui]: '3',
            [p13nServiceDecisions.listingDraft]: '1',
        }
        Listing.number = personalizedListingVersion[P13N.preShipmentUi] || '1'

        return I18n.getString(`listingPage::versions::v${Listing.number}`);
    }

    static setVersion(props) {
        Listing.version = this.getVersion(props)
    }

    static goTo = (siteLink, message, itemId, noRootUrl = false, stopAnimation) => {
        if (stopAnimation) {
            stopAnimation();
        }
        UserActions.listingPage(message, itemId, Listing.version);

        window.open(noRootUrl ? siteLink : `${rootUrl(siteLink)}`,isMobile() ? '_self' : '_blank');
    }

    componentDidUpdate() {
        const { noPhoneSurveyPresented } = this.state
        const { item, P13N, ADO } = this.props;

        if (item instanceof WorthyApiErrors && item.hasError(404)) {
            return
        }

        if (item && !P13N.preShipmentUi && !this.gettingP13N && ADO && ADO.user) {
            this.props.preShipmentUi(item, ADO.user);
            this.gettingP13N = true
        }

        const observerOptions = {
            root: null,
            rootMargin: '0px',
        };

        if (this.isMobile) {
            if (item && item.properties && !this.bottomStickyObserver && this.state.initialized) {

                const observerStickyCb = entries => {
                    const element = entries[0];
                    if (entries.length === 1) {
                        this.setState({ showStickyShipmentButton: element.intersectionRatio === 0});
                    }
                };
                this.bottomStickyObserver = new IntersectionObserver(observerStickyCb, { ...observerOptions, threshold: 0 });
                this.bottomStickyObserver.observe(this.shallWeSection.current);
                this.bottomStickyObserver.observe(this.pageHeader.current);
            }
        } else if (this.state.initialized) {
            if (!this.desktopStickyObserver) {
                const desktopObserverStickyCb = entries => {
                    const element = entries[0];
                    let currentY = element.boundingClientRect.y
                    if (entries.length === 1) {
                        this.setState({
                            showStickyShipmentButtonDt: element.intersectionRatio === 0 && currentY < this.state.prevObserverYPosition,
                            stickyBoxStyle: element.intersectionRatio === 0 &&currentY < this.state.prevObserverYPosition ? 'fixedBox' : '',
                            prevObserverYPosition: currentY
                        });
                    }
                };
                this.desktopStickyObserver = new IntersectionObserver(desktopObserverStickyCb, { ...observerOptions, threshold: 0 });
                this.desktopStickyObserver.observe(this.headAlert.current);
            }
            if (!this.desktopStickyObserver2) {
                const desktopObserverStickyCb = entries => {
                    const element = entries[0];
                    if (entries.length === 1) {

                        this.setState({ stickyBoxStyle: element.intersectionRatio === 0 ? 'stickyBox' : this.state.showStickyShipmentButtonDt ? 'fixedBox' : '' });
                    }
                };
                this.desktopStickyObserver2 = new IntersectionObserver(desktopObserverStickyCb, { ...observerOptions, threshold: 0 });
                this.desktopStickyObserver2.observe(this.settingsSection.current);
            }
        }
        if (!noPhoneSurveyPresented) {
            this.handleNoPhoneSurveyModal()
        }
    }

    componentWillUnmount() {
        if (this.bottomStickyObserver) {
            this.bottomStickyObserver.unobserve(this.shallWeSection.current);
            this.bottomStickyObserver.unobserve(this.pageHeader.current);
        }
        if (this.desktopStickyObserver) {
            this.desktopStickyObserver.unobserve(this.headAlert.current);
        }
        if (this.desktopStickyObserver2) {
            this.desktopStickyObserver2.unobserve(this.settingsSection.current);

        }
    }

    componentDidMount() {
        const {ADO} = this.props;

        if (ADO && ADO.intercomDataEvent) {
            Intercom.updateContactData(JSON.parse(ADO.intercomDataEvent));
        }
    }

    handleNoPhoneSurveyModal() {
        const { item, ADO } = this.props;
        const listing_page_no_phone_modal = item && item.listing_page_no_phone_modal
        const shouldOpenNoPhoneModal = this.isMobile &&
            listing_page_no_phone_modal &&
            listing_page_no_phone_modal.enable_listing_draft_no_phone_survey &&
            ADO && ADO.user && ADO.user.phone === DEFAULT_PHONE &&
            !LS.get('listingDraftNoPhoneModalPresented')
        if (shouldOpenNoPhoneModal) {
            const delay = (item && item.listing_page_no_phone_modal &&
                item.listing_page_no_phone_modal.listing_draft_no_phone_survey_delay * 1000) // turn to milliseconds
                || 3000
            this.setState({noPhoneSurveyPresented: true});
            setTimeout(() => {
                LS.set('listingDraftNoPhoneModalPresented', true);
                this.setState({showNoPhoneSurvey: true});
            }, delay)
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        // This callback reduces rerender cycles but limits the component children to be re-rendered via properties
        // so add any additional condition in order to control render process
        return nextProps.ADO && nextProps.item && nextProps.Session;
    }

    static openAttrPopup(item, propertiesToBeDefined) {
        const TABLE_OF_PROPERTIES = `<div class='table-wrapper'><table>${
            propertiesToBeDefined
                .map(property => '<tr><td>' + property + '</td><td><b>' + I18n.getString('listingPage::toBeDefined') + '</b></td></tr>')
                .join('')
            }</table></div>`;

        PopupListing.initPopup({
            classNames: ['settings-popup', 'no-animation'],
            title: I18n.getString('listingPage::attrPopupTitle'),
            content: I18n.getString('listingPage::attrPopupContent').replace('%table%', TABLE_OF_PROPERTIES),
            dangerous: true,
            onOpen: () => {
                UserActions.listingPage('Item additional properties being added by experts popup has been opened', item.id, Listing.version);
            },
            onClose: () => {
                UserActions.listingPage('Item additional properties being added by experts popup has been closed', item.id, Listing.version);
            }
        })
    }

    openLiveChat = (stopAnimation) => {
        if (stopAnimation) {
            stopAnimation()
        }
        let that = this;
        UserActions.listingPage('Chat with us clicked', this.props.item.id, Listing.version);
        let message = I18n.getString('listingPage::chat::welcomeMessage', {name: this.props.ADO && this.props.ADO.user ? this.props.ADO.user.first_name : ''});
        window.SnapEngage.openProactiveChat(true, true, message);
        this.setState({isChatOpen: true});
        setTimeout(()=> {
            window.SnapEngage.startChat(message);
            window.SnapEngage.setCallback('Close', function (type, status) {
                that.setState({isChatOpen: false});
            })
        },1000)
    }

    // checkAvailability = () => {
    //     let that =this;
    //     setTimeout(()=> {
    //         if(window.SnapEngage) {
    //             window.SnapEngage.getAgentStatusAsync(function (online) {
    //                 that.setState({availableAE: online})
    //             });
    //         }
    //     }, 3000)
    // }

    static handleScrollDownLinkClick () {
        const shipmentDomElement = document.getElementById(SHIPMENT_DOM_ID);
        const headerDomElement = document.getElementsByTagName('header') && document.getElementsByTagName('header')[0];
        // FIXME: somehow react-scroll to bottom offset doesn't works as well as scrollto dom element
        if (shipmentDomElement && headerDomElement) {
            window.scrollTo({
                top: shipmentDomElement.offsetTop - headerDomElement.offsetHeight,
                behavior: 'smooth'
            });
        }
    }

    static shipmentInfoMessage(item, type) {
        return () => {
            let ALL_SET;
            let FOR_MORE;

            if (type) {
                if (type === SHIPPING_KIT) {
                    ALL_SET = I18n.getString('listingPage::shippingKit');
                    FOR_MORE = I18n.getString('listingPage::scheduledShipmentNotificationForMore')
                }
            } else {
                ALL_SET = I18n.getString('listingPage::scheduledShipmentNotificationAllSet');
                FOR_MORE = item.shipment && item.shipping_label ?
                    I18n.getString('listingPage::scheduledShipmentNotificationDownloadShippingLabel') :
                    I18n.getString('listingPage::scheduledShipmentNotificationInsuranceInfo');

                if (item.shipment && item.shipment.shipment_method && item.shipment.shipment_method === SHIPMENT_METHOD['Drop Off']) {
                    ALL_SET = I18n.getString('listingPage::scheduledShipmentNotificationDropOffOverPickup');
                    FOR_MORE = I18n.getString('listingPage::scheduledShipmentNotificationForMore');
                }
            }

            const SCROLL_DOWN = <a key='success-alert-link'
                className="success-text-link"
                onClick={ Listing.handleScrollDownLinkClick }
                style={{ fontWeight: 600 }}>{ I18n.getString('listingPage::scrollDown') }</a>;

            return (<div key='success-alert-message' style={stylesForText}>
                <span key='all-set-span'>{ ALL_SET }</span> { SCROLL_DOWN } <span key='scroll-sown'>{ FOR_MORE }</span>
            </div>)
        }
    }

    shouldOpenCompleteAccountModal = (shouldOpen) => {
        this.setState({openCompleteAccountModal: shouldOpen})
    }

    renderSimilarItemsSection = (item) => {
        return (
            <Grid className='listing' container spacing={0}>
                <div className={'listing-content'}>
                    <SimilarItemsContainer
                        items={ item['similar_items'] }
                        goTo={ Listing.goTo }
                        item={ item }
                        userActionsCb={ UserActions.listingPage }
                        version={Listing.version}/>
                </div>
            </Grid>
        )
    }

    updateSticky = () => {
        this.setState({bannerPresented: !this.state.bannerPresented})
    }

    renderStagesSection = (item) => {
        // FIXME: remove once this data is being fetched from the backend/API
        const itemStage = 1; // Expecting shipping
        return (
            <Grid item xs={this.isMobile ? 12 : 9}>
                <Stages step={ itemStage } item={ item } version={Listing.version} showBannerCb={this.updateSticky}/>
            </Grid>
        )
    }

    renderFAQSection = (item, experiments, P13N) => {
        // console.log('UserActions.listingPage', UserActions.listingPage);
        return (
            <Grid container className='listing ' spacing={0}>
                <div className={'listing-content'}>
                    <ListingFAQ
                        experiments={ experiments }
                        item={item}
                        parent={Listing}
                        userActionsCb={ UserActions.listingPage }
                        P13N={P13N}
                        needsTitle={true}/>
                </div>
            </Grid>
        )
    }

    renderChatSection(){
        return (
            this.state.availableAE ?
            <div className={'listing-content'}>
                <Grid item xs={9} className='chat-with-us'>
                    <img className='chat-icon' src={ imageUrl('listing/chat.svg') } />
                    <h2 className='chat-title listing-title h2'>{ I18n.getString('listingPage::chat::title') }</h2>
                    <div className='chat-text'>{ I18n.getString('listingPage::chat::text') }</div>
                    <LargeSecondaryButton
                        text={ I18n.getString('listingPage::chat::button') }
                        disabled={ this.state.isChatOpen }
                        click={ (stopAnimation) => this.openLiveChat(stopAnimation) }/>
                </Grid>
            </div>
                : null
        )
    }

    openSSFonMobile = (itemId, step) => {
        this.logAction('Set up shipment modal presented', { itemId, version: Listing.version });
        this.setState({ openSchedulePickupForm: true, step: step });
    }

    closeSchedulePickupForm = (step) => {
        this.setState({ openSchedulePickupForm: false, step: step });
        if (this.stopAnimation) { this.stopAnimation() }
    }

    logAction = (message, params) => {
        UserActions.listingPage(message, params.itemId, params.version);
    }

    renderShipmentInformation(item){
        return (
            <div className={'listing-content text-center'} style={{width: "100%"}} ref={this.shallWeSection}>
                {!item.shipment ? <h2 className='listing-title h2'>{ I18n.getString('listingPage::scheduleTitle')}</h2> : null}
                <ShipmentInformation
                    openSchedulePickupFormForMobile={this.openSSFonMobile}
                    logger={this.logAction}
                    id={SHIPMENT_DOM_ID}
                    item={item}
                    editable={true}
                    isSKExperiment={Listing.getVersion(this.props) === LD_SK_EXP_VERSION}
                    version={Listing.version}/>
            </div>
        )
    }

    renderRightInfoBox(item){
        if (this.isMobile) {
            return null;
        }

        let NEXT_UP_TEXT = <span className='text'>{ I18n.getString(`listingPage::nextUp::freeAndSecure`)}</span>
        let NEXT_UP_BUTTON_TEXT = I18n.getString('listingPage::scheduleButtonNotSecure');
        let NEXT_UP_BUTTON_STEP = STEP_PHONE;

        const requestShippingKitExperiment = Listing.getVersion(this.props) === LD_SK_EXP_VERSION;

        const SKNew = item.shipping_kit && item.shipping_kit.status === NEW;
        const SKInTransit = item.shipping_kit && item.shipping_kit.status === IN_TRANSIT;
        const shippingKitNotYetDelivered = item.shipment && requestShippingKitExperiment && (SKNew || SKInTransit);

        if (item.shipment && !shippingKitNotYetDelivered) {
            NEXT_UP_BUTTON_STEP = STEP_PICKUP;
            NEXT_UP_BUTTON_TEXT = I18n.getString('shipmentInformation::schedulePickupButton');
            if (item.shipment.shipment_method === SHIPMENT_METHOD['Drop Off']) {
                NEXT_UP_TEXT = <div>
                    <span className='text'>{ I18n.getString(`listingPage::nextUp::dropOff::label`)}</span>
                    <a key='success-alert-link-in-box'
                       className="success-text-link orange"
                       onClick={ Listing.handleScrollDownLinkClick }
                       style={{ fontWeight: 600 }}>{ I18n.getString(`listingPage::nextUp::dropOff::linkText`) }</a>
                </div>;
            } else if (item.shipment.shipment_method === SHIPMENT_METHOD['Pickup']) {
                NEXT_UP_TEXT = <div>
                    <span className='text'>{ I18n.getString(`listingPage::nextUp::pickup::label`)}</span>
                    <a key='success-alert-link-in-box'
                       className="success-text-link orange"
                       onClick={ Listing.handleScrollDownLinkClick }
                       style={{ fontWeight: 600 }}>{ I18n.getString(`listingPage::nextUp::pickup::linkText`) }</a>
                </div>;
                NEXT_UP_BUTTON_TEXT = I18n.getString('shipmentInformation::editPickupButton')
            }
        }
        let NEXT_UP_BUTTON = <MediumPrimaryButton
            text={NEXT_UP_BUTTON_TEXT}
            disabled={false}
            click={(stopAnimation) => {
            const message = `${ item.shipment ? 'Edit' : 'Schedule' } button clicked (Next Up [desktop])`;
                this.logAction(message, { itemId: item.id, version: Listing.version });
                ScheduleShipmentModalPopup.initPopup({
                    step: NEXT_UP_BUTTON_STEP,
                    stopAnimation: stopAnimation,
                    version: Listing.version,
                    itemId: item.id,
                    isSKExperiment: Listing.getVersion(this.props) === LD_SK_EXP_VERSION
                });
            }}
        />;

        if (shippingKitNotYetDelivered) {
            // Disable "Schedule Shipment" CTA on Desktop for Shipping Kit's "New" and "In Transit" states;
            NEXT_UP_BUTTON = null;
        }

        return <Grid item xs={3} className='item-info-box'>
            <div className='next-up'>
                <div className='title'>{ I18n.getString(`listingPage::nextUp::next`)}</div>
                {NEXT_UP_TEXT}
            </div>
            <div className='listing-next-up-button'>
                {NEXT_UP_BUTTON}
            </div>
            <div className='trust-icons'/>
        </Grid>
    }

    renderItemInfoSection() {
        const itemPropertiesToBeDefined = I18n.getVar(`listingPage::itemPropertiesToBeDefined::loose diamond`);
        // FIXME: turn it on back once we have correct property list
        // const itemPropertiesToBeDefined = I18n.getVar(`listingPage::itemPropertiesToBeDefined::${ Item.item_type }`);
        const ATTRS_AMOUNT = itemPropertiesToBeDefined.length;
        let {
            showDraftWelcome,
            showStickyShipmentButton
        } = this.state;

        const { item } = this.props;

        let NEXT_UP_BUTTON_STEP = item.shipment ? STEP_PICKUP : STEP_ADDRESS;

        const requestShippingKitExperiment = Listing.getVersion(this.props) === LD_SK_EXP_VERSION;

        const SKNew = item.shipping_kit && item.shipping_kit.status === NEW;
        const SKInTransit = item.shipping_kit && item.shipping_kit.status === IN_TRANSIT;

        const shippingKitNotYetDelivered = item.shipment && requestShippingKitExperiment && (SKNew || SKInTransit);

        return (
            <div style={{ width: '100%' }} ref={this.settingsSection}>
                {
                    shippingKitNotYetDelivered || !this.isMobile ? null : <StickyButton
                        show={this.isMobile && showStickyShipmentButton && !this.state.isChatOpen}
                        text={item.desc}
                        btnText={Listing.STICKY_BUTTON_TEXT}
                        onClick={ (stopAnimation) => {
                            const message = `«${ Listing.STICKY_BUTTON_TEXT }» Sticky button clicked`;
                            this.logAction(message, { itemId: item.id, version: Listing.version });
                            if (this.isMobile) {
                                window.localStorage.setItem(OPENED_SCHEDULE_MODAL+`_${item.id}`, true)
                                const hasAddress = item.shipment && item.shipment.formatted_address
                                this.setState({ openSchedulePickupForm: true, step: hasAddress? STEP_PICKUP: STEP_PHONE})
                            } else {
                                ScheduleShipmentModalPopup.initPopup({
                                    step: NEXT_UP_BUTTON_STEP,
                                    stopAnimation: stopAnimation,
                                    version: Listing.version,
                                    isSKExperiment: Listing.getVersion(this.props) === LD_SK_EXP_VERSION,
                                    itemId: item.id
                                });
                            }

                            if (stopAnimation) {
                                stopAnimation();
                            }
                        }}
                    />
                }
                <div ref={this.headAlert}>
                    <ListingAlerts isMobile={this.isMobile}
                                   handleScrollDownLinkClick={Listing.handleScrollDownLinkClick}
                                   itemId={this.props.params.itemId}
                                   userActionsCb={ UserActions.listingPage }
                                   shouldOpenCompleteAccountModal={this.shouldOpenCompleteAccountModal}
                                   version={Listing.version}
                    />
                </div>
                <h1 ref={this.pageHeader} key='title' className='listing-title-b h1'>{ I18n.getString(`listingPage::title`)}</h1>

                <Grid container direction="row"
                      justify="space-between"
                      spacing={0}>
                    <Grid item xs={this.isMobile ? 12 : 8} className='item-info-box left'>
                        <Settings item={ item } version={Listing.version}/>
                        <div className='microscope-alert-wrapper' onClick={ () => Listing.openAttrPopup(item, itemPropertiesToBeDefined) }>
                            <InfoMicroscopeAlert
                                onClose={ () => {} }
                                canClose={false}
                                text={ I18n.getString('listingPage::attrAlert').replace('%propertiesNum%', ATTRS_AMOUNT) }
                                marginVsides='sm'/>
                        </div>
                    </Grid>
                    {this.isMobile ? null :
                        <div className={this.state.showStickyShipmentButtonDt ? 'disableMe' : 'rightStickyBox'}>
                            {this.renderRightInfoBox(item)}
                        </div>
                    }
                </Grid>
            </div>

        )
    }

    shipmentScheduledSuccessfully = (data) => {
        if (Listing.getVersion(this.props) === LD_SK_EXP_VERSION) {
            return this.setState({ step: STEP_MESSAGE });
        }
    }

    openScheduleReminderPopup = () => {
        UserActions.listingPage('Remind me later button clicked', this.props.item.id, Listing.version);
        if (this.isMobile) {
            this.setState({ openRemindLaterForm: true })
        } else {
            PopupListingReminder.initPopup({ step: 1, version: Listing.version })
        }
    }

    renderRemindLater = () => {
        const {
            item,
            ADO,
            P13N
        } = this.props;

        const UIAnalysis = Item.analyzeItemState(item, ADO, P13N, {}, null);
        const anyHybridCui = UIAnalysis && UIAnalysis.anyHybridCui;

        if (Listing.getVersion(this.props) === LD_SK_EXP_VERSION || anyHybridCui) return;
        const preShippingListingStates = item.workflow_state === ESTIMATION_READY ||
            (item.workflow_state === SHIPPING &&
                (item.bundle.workflow_state === ADDRESS_WAITING || item.bundle.workflow_state === PICKUP_WAITING) &&
                !(item.shipment && item.shipment.active_pickup));

        return (
            preShippingListingStates ?
                <div className={'listing-content maybe-later-button-wrapper text-center'}
                    style={{width: "100%", paddingBottom: "20px"}}
                    data-automation='maybe_later'>
                    <LargeLinkButton text={ I18n.getString('listingPage::remindLater::text') }
                                     click={ () => this.openScheduleReminderPopup() }/>
                </div>
            : null
        )
    }

    renderPage(item, experiments, P13N) {
     const { showRequestSKPopup } = this.state;
        return (
            <div>
                <div className={`listing-main-wrapper ${!this.isMobile ? 'listing' : ''}`}>
                    <Grid className='listing' container spacing={0}>
                        {this.renderItemInfoSection()}
                    </Grid>
                    <div
                        className={`scrolledBox ${this.state.stickyBoxStyle} ${this.state.bannerPresented ? 'animateBannerIn' : 'animateBannerOut'}`}
                        // style attr for absolute sticky box
                        style={{right: (window.innerWidth - 1000) / 2}} >
                        {this.renderRightInfoBox(item)}
                    </div>
                    <Grid className='listing listing-full-width'>
                        {this.renderStagesSection(item)}
                    </Grid>
                    <Grid className='listing listing-full-width-mobile'>
                        <Services itemId={item.id} version={Listing.version}/>
                    </Grid>
                {this.renderFAQSection(item, experiments, P13N)}
                </div>
                {this.renderSimilarItemsSection(item)}
                <Grid container className='listing' spacing={0}>
                    { showRequestSKPopup ? this.renderRequestSKPopup() : null }
                    {this.renderModal()}
                    {this.renderShipmentInformation(item)}
                    {this.renderRemindLater()}
                    {/*{this.renderChatSection()}*/}
                    {this.renderTrustLogos()}
                    {this.renderNoPhoneSurvey()}
                </Grid>
            </div>
        )
    }

    onRequestSK = () => {
        this.setState({ showRequestSKPopup: true, openSchedulePickupForm: false });
    }

    hideSKPopup = () => {
        this.setState({ showRequestSKPopup: false })
    }

    renderRequestSKPopup = () => {
        const { item } = this.props;

        return <div className="shipping-kit-request-popup">
            <div className="shipping-kit-request-popup__inner">
                <LongCtaPopup
                    headline={ I18n.getString('shippingKit::popup::headline') }
                    html={ requestShippingKitPopupText(item.shipment.shipment_method) }
                    declineButtonText={ I18n.getString('shippingKit::popup::declineButton') }
                    approveButtonText={ I18n.getString('shippingKit::popup::approveButton') }
                    declineButtonClick={ () => this.hideSKPopup() }
                    approveButtonAutomationAttribute='get-shipping-kit-btn'
                    approveButtonClick={ (stopAnimation) => {
                        this.doRequestSK(stopAnimation)
                    } }
                />
            </div>
        </div>
    }

    doRequestSK = (stopAnimation) => {
        const {
            onSuccess,
            item,
            experiments,
            requestShippingKit
        } = this.props;

        if (!item || !experiments) {
            console.error('Either item or experiments are missing in props input object');
            return
        }

        UserActions.listingPage('Get shipping kit - approved', item.id, Listing.getVersion(this.props));

        if (this.isMobile) {
            this.hideSKPopup();
        }

        return requestShippingKit(item.id).then(data => {
            if (onSuccess) {
                onSuccess();
            }
            if (stopAnimation) {
                stopAnimation()
            }
        }).catch(err => {
            if (stopAnimation) {
                stopAnimation()
            }
        });
    }

    renderModal = () => {
        const {
            openSchedulePickupForm,
            openRemindLaterForm,
            customStepTitle,
            step,
            openCompleteAccountModal
        } = this.state;

        const {
            item,
            P13N
        } = this.props;

        // TODO: WORTHY:11005 Request SK Exp
        const ShippingKitExperiment = [STEP_MESSAGE, STEP_PICKUP].includes(step) && Listing.getVersion(this.props) === LD_SK_EXP_VERSION;

        const SSSF_STEP_TITLE = customStepTitle || I18n.getString(`listingPage::${ item.shipment && step === STEP_PICKUP ? 'scheduleShipmentTitle' :
            ShippingKitExperiment ? 'allSet' : 'setUpShipmentTitle'}`)
        return (
            openSchedulePickupForm ?
                <ModalPattern
                    key={'ModalPattern'}
                    textAlign={'center'}
                    title={ SSSF_STEP_TITLE }
                    closeIcon={ true }
                    closeOnClickOutside={ false }
                    closeOnEscape={ false }
                    isWide={ true }
                    onClose={ () => {
                        this.setState({ openSchedulePickupForm: false });
                        // if (onClose) { onClose(step); }
                    }}>
                    <ScheduleShipment
                        version={Listing.version}
                        onClose={(step) => this.closeSchedulePickupForm(step) }
                        handleScrollDownLinkClick={Listing.handleScrollDownLinkClick}
                        onSetCustomWrapperTitle={ (title) => { this.setState({ customStepTitle: title }) }}
                        onShipmentScheduled={ data => this.shipmentScheduledSuccessfully(data) }
                        onRequestShippingKit={this.onRequestSK}
                        isSKExperiment={Listing.getVersion(this.props) === LD_SK_EXP_VERSION}
                        step={step}
                    />
                </ModalPattern>
            : openRemindLaterForm ?
                <ModalPattern
                    key={'ReminderModalPattern'}
                    textAlign={'center'}
                    closeIcon={ true }
                    closeOnClickOutside={ false }
                    closeOnEscape={ false }
                    isWide={ true }
                    onClose={ () => {
                        this.setState({ openRemindLaterForm: false});
                    }}>
                    <ListingReminder
                        version={Listing.version}
                    />
                </ModalPattern>
            : openCompleteAccountModal ? ListingAlerts.completeAccountModal(this.props, Listing.version, this.shouldOpenCompleteAccountModal, UserActions.listingPage) : null
        )
    }

    renderNoPhoneSurvey() {
        const { showNoPhoneSurvey, surveyTitle  } = this.state;
        const { item } = this.props;
        if(item) {
            const ObjectId = item.id;
            const ObjectType = 'Item';
            const surveyToShow = 'listingDraftNoPhone'
            return (<div>
                { showNoPhoneSurvey ?
                    <ModalPattern key={'ModalPattern'}
                                  textAlign={'center'}
                                  title={ surveyTitle || I18n.getString(`survey::${surveyToShow}::title`) }
                                  closeIcon={ true }
                                  closeOnClickOutside={ false }
                                  isWide={true}
                                  closeOnEscape={ false }
                                  onClose={ () => {
                                      UserActions.survey('Survey modal closed', ObjectId, ObjectType, '', surveyToShow);
                                      this.setState({ showNoPhoneSurvey: false });
                                  }}>
                        <Survey ObjectId={ObjectId}
                                ObjectType={ObjectType}
                                setTitleMobile={(title)=> {this.setState({surveyTitle: title})}}
                                surveyToShow={surveyToShow || 'default'}
                                className='listing-draft-no-phone-container'
                                onClose={() => {
                                    UserActions.survey('Survey modal closed', ObjectId, ObjectType, '', surveyToShow);
                                    this.setState({showNoPhoneSurvey: false})
                                }}/>
                    </ModalPattern>: null
                }
            </div>)

        } else {
            return null
        }
    }

    renderTrustLogos(){
        return(
          <div className={'listing-content'}>
              <div className={'trust-logos-seller-note-container'}>
                  <img src={imageUrl('common/logos/fedex_gray_logo.svg')} alt="Fedex" />
                  <img src={imageUrl('common/logos/lloyds_gray.svg')} alt="Lloyds" />
                  <img src={imageUrl('common/logos/gray_GIA.svg')} alt="GIA" />
              </div>
          </div>
        );
    }

    render() {
        const {
            Session,
            item,
            getItem,
            experiments,
            P13N
        } = this.props;

        const {
            requestingNewItem
        } = this.state;

        const LOGGED_IN = Session && Session.isLoggedIn;

        if (item instanceof WorthyApiErrors && item.hasError(404)) {
            if (LOGGED_IN) {
                return requestingNewItem ? <ListingSkeleton/> : <NoMatch />;
            } else return <Login
                showLinkToRegister={ true }
                onSubmitForm={ () => {
                    this.setState({ requestingNewItem: true });
                } }
                onLoginSuccessful={ () => {
                    getItem(this.props.params.itemId, false, this.props.location.query).then(() => {
                        this.setState({ requestingNewItem: true });
                    });
                } }/>
        }

        if (item && item.properties && experiments && P13N.preShipmentUi) {
            return this.renderPage(item, experiments, P13N)
        } else {
            return <ListingSkeleton/>;
        }
    }
}

const mapStateToProps = ({ ADO, Item, Session, Experiments, Personalized }) => {
    return {
        item: Item,
        ADO,
        Session,
        experiments: Experiments,
        P13N: Personalized,
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ requestShippingKit, getItem, preShipmentUi }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Listing);
